import classnames from 'classnames';
import type { ItemStyle } from 'react-tiny-virtual-list';
import { t } from 'src/lib/player/i18n';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';
import { HEADER_HEIGHT } from '../SideBar';
import { HideButton } from './HideButton';

export type TrackHeaderProps = {
  style: ItemStyle;
  isOpen: boolean;
  allHidden: boolean;
  onToggle: () => void;
  onHide: () => void;
  onUnhide: () => void;
};

export function TrackHeader({
  style,
  isOpen,
  allHidden,
  onToggle,
  onHide,
  onUnhide,
}: TrackHeaderProps): JSX.Element {
  return (
    <div
      className={classnames('starter-list-header', { open: isOpen })}
      style={{
        ...style,
        height: HEADER_HEIGHT,
        zIndex: 1000 + (style.zIndex || 0),
      }}
    >
      <div className="starter-list-header-item" {...onClickGenerator(onToggle)}>
        {isOpen ? (
          <i className="fas fa-chevron-down" />
        ) : (
          <i className="fas fa-chevron-down fa-rotate-270" />
        )}
        &nbsp;
        <div className="starter-list-header-item-label">{t('list.TRACK')}</div>
        <HideButton allHidden={allHidden} onHide={onHide} onUnhide={onUnhide} />
      </div>
    </div>
  );
}
